import type React from "react";

import { Typography, type TypographyPropsVariantOverrides, type TypographyVariant } from "@mui/material";

import { useLocalizedDate } from "utils/date";

const capitalizeFirstLetter = (stringToCapitalize: string) => {
  const [first, ...rest] = stringToCapitalize.split("");
  return [first.toUpperCase(), ...rest].join("");
};

interface Props {
  dateString: string;
  capitalize?: boolean;
  shortFormat?: boolean;
  typographyVariant?: TypographyVariant | keyof TypographyPropsVariantOverrides;
}

export const RelativeDatetime: React.FC<Props> = ({
  dateString,
  capitalize = false,
  shortFormat = false,
  typographyVariant,
}) => {
  const { parseISO, isValid, formatRelative } = useLocalizedDate();

  if (!dateString) return <></>;

  const parsedDate = parseISO(dateString);
  if (!isValid(parsedDate)) return <></>;
  const formatted = formatRelative(parsedDate, shortFormat);
  const relativeDateTime = capitalize ? capitalizeFirstLetter(formatted) : formatted;

  if (typographyVariant) {
    return <Typography variant={typographyVariant}>{relativeDateTime}</Typography>;
  }

  return <>{relativeDateTime}</>;
};
